/**
 * BE-153 — `GET /gift/config?currency=` (public): the gift quiz's occasions and budget bands from
 * the published `default-gift-survey` definition, labels in `Accept-Language`, budgets per
 * currency, and the who step's relations / age ranges / genders. `ETag` / `Cache-Control` on the wire.
 */
import { apiClient } from '@/api/api'

export interface GiftConfigOccasion {
  key: string
  label: string
}

export interface GiftConfigBudget {
  key: string
  label: string
  min: number | null
  max: number | null
}

/** 2026-10-22 (migration 108) — a who-step option: a relation or a gender. */
export interface GiftConfigOption {
  key: string
  label: string
}

/** An age range and the genders the person form offers for it (`under-18` → girl / boy). */
export interface GiftConfigAgeRange extends GiftConfigOption {
  genders: string[]
}

export interface GiftConfig {
  occasions: GiftConfigOccasion[]
  /** The who step's lists; empty on a definition published before migration 108. */
  relations: GiftConfigOption[]
  ageRanges: GiftConfigAgeRange[]
  genders: GiftConfigOption[]
  /** By ISO-4217 code (`USD`, `EUR`, `GBP`, `RUB`). */
  budgets: Record<string, GiftConfigBudget[]>
  defaultCurrency: string
  /** The ranges are the design's placeholders until the product sets them. */
  placeholderBudgets: boolean
  definitionVersion: number
}

export const getGiftConfig = (currency?: string) =>
  apiClient.get<GiftConfig>('/gift/config', { params: currency ? { currency } : {} })
